<app-mit-dialog *ngIf="dialogFields" [formGroup]="formGroup" [dialogFields]="dialogFields" [callback]="callback"></app-mit-dialog>
